import { EsignatureType } from '~/enums/EsignatureType';
import { ServiceRequestConfig } from '~/services/createService';
import { everest } from '~/services/serviceInstances';

export type TicketEligibility = {
  ticket_id: string;
  is_valid: boolean;
  reason?: string;
  message?: string;
};

export type ValidateMultiTicketBundleRequest = {
  ticket_ids: string[];
  vendor?: EsignatureType;
};

export type ValidateMultiTicketBundleResponse = {
  is_valid: boolean;
  message?: string;
  tickets: TicketEligibility[];
};

export const validateMultiTicketBundle = (
  request: ValidateMultiTicketBundleRequest,
  options: ServiceRequestConfig = {},
): Promise<ValidateMultiTicketBundleResponse> =>
  everest.post(
    '/packages/multi-ticket/validate',
    {
      ticket_ids: request.ticket_ids,
      ...(request.vendor && { vendor: request.vendor.toUpperCase() }),
    },
    {
      showErrorToast: true,
      ...options,
    },
  );
